<div class="select-container" [ngClass]="styleApplied" appClickOutside (clickOutside)="clickOutside()" [isActive]="isListShown">
    <div class="select-input-wrapper bg-fff input-wrapper" (click)="handleTriggerClick()" [ngStyle]="showError()? {'border':'1px solid #B00020'}:{}"> 
      <!-- <mat-form-field appearance="outline" class="input-form-field"> -->
      <!-- <input 
        matInput -->
      <input class="select-input input fs-12"
        [disabled]="formControl && formControl.disabled"
        [placeholder]="placeholder"
        [(ngModel)]="displayValue"
        (blur)="handleInputBlur()"
        (keyup)="handleInputChange($event)"
        (keypress)="checkInput($event)"
        (keydown)="setHighlightedOption($event)"
        [ngClass]="{'input-error':  showError(), 'has-clear': showClear}"
        style="border: 0;"
        (keypress)="checkKeys($event)"
        (paste)="validateInput($event)"
      />
        <img *ngIf="displayValue" src="assets/cross_icon.svg" class="mr-4"  (click)="clearInput($event)" class="input-icon clear-icon">
        <img src="assets/divider.svg" class="mr-8">
        <img src="assets/map_pin.svg" matTooltip="Select on Map"  matTooltipClass="booking-table-tooltip" class="cursor-pointer" (click)="setMap()"
        [ngClass]="{'disabled':disbaleIcon}">
    </div>
    <ul class="select-list" [ngClass]="{'with-attribution': showGoogleAttribution}" *ngIf="isListShown && selectOptions.length">
      <li class="select-option address"
        *ngFor="let option of selectOptions; let optionIndex = index"
        (click)="onOptionClick(option)"
        [ngClass]="{'active-item': optionIndex == activeOption}"
      >
        <ng-container *ngIf="option && option.isSaved">
          <div class="fs-12 color-181F33 ellipsis">{{option.type || option.address}}</div>
          <div *ngIf="option.type" class="secondary ellipsis">{{option.address}}</div>
        </ng-container>
        <ng-container *ngIf="!option.isSaved">
          <div class="fs-12 color-181F33 ellipsis">{{option.structured_formatting.main_text}}</div>
          <div class="secondary ellipsis">{{option.structured_formatting.secondary_text}}</div>
        </ng-container>
    </li>
      <li class="no-results" *ngIf="selectOptions.length == 0">No results found</li>
    </ul>
    <div class="error-msg address-error" *ngIf="showError() && formControl.errors.required"> <img src="assets/error-16.svg" alt="" class="error-icon mr-4">{{errorMessages.required}}</div>
    <div class="error-msg address-error" *ngIf="showError() && formControl.errors.secure"><img src="assets/error-16.svg" alt="" class="error-icon mr-4">{{errorMessages.pattern}}</div>
    <div class="error-msg address-error" *ngIf="showError() && formControl.errors.outsideBounds"><img src="assets/error-16.svg" alt="" class="error-icon mr-4">{{errorMessages.outsideBounds}}</div>
    <div class="error-msg address-error" *ngIf="showError() && formControl.errors.airportRequired"><img src="assets/error-16.svg" alt="" class="error-icon mr-4">{{errorMessages.airportRequired}}</div>
  </div>

  <app-popover *ngIf="openMap" size="full" titleText="Add address" (closeCallback)="openMap=false">
    <div popover-content >
      <div class="displayFlex align-item-center fs-12 mb-16 geoaraea-label">
        <span> <img src="assets/ic-action-info-24.svg" alt=""></span>
        <span class="ml-8 mb-2">Please enable location permission in your browser and drag the pin on the map to set the address.</span>
      </div>
      <div class="searchbar mb-16 displayFlex align-item-center">
        <img src="assets/ic-action-search-24.svg" class="mr-4">
        <input class="select-input input fs-12"
        placeholder="Search Address"
        [(ngModel)]="displayAddress"
        (ngModelChange)="searchAddress($event)"
        (keypress)="checkInput($event)"
        (paste)="validateInput($event)"
        (keypress)="checkKeys($event)"
      />
      </div>

      <ul class="select-address-list"  *ngIf="showAddressList && selectOptions.length">
        <li class="select-option address"
          *ngFor="let option of selectOptions; let optionIndex = index"
          (click)="onOptionClick(option)"
          [ngClass]="{'active-item': optionIndex == activeOption}"
        >
          <ng-container *ngIf="option && option.isSaved">
            <div class="fs-12 color-181F33 ellipsis">{{option.type || option.address}}</div>
            <div *ngIf="option.type" class="secondary ellipsis">{{option.address}}</div>
          </ng-container>
          <ng-container *ngIf="!option.isSaved">
            <div class="fs-12 color-181F33 ellipsis">{{option.structured_formatting.main_text}}</div>
            <div class="secondary ellipsis">{{option.structured_formatting.secondary_text}}</div>
          </ng-container>
      </li>
        <li class="no-results" *ngIf="selectOptions.length == 0">No results found</li>
      </ul>

      <div class="map-section">
        <div id="map-container"></div>
      </div>
      <div class="mt-16 displayFlex align-item-center ">
        <span class="fs-12 geoaraea-label">Address Details</span>
        <div class="address-box" matTooltip="{{selectedAddress?.description}}"  matTooltipClass="addressTooltip">{{selectedAddress?.description}}</div>
      </div>
    </div>
    <div popover-actions class="flex flex-end">
      <app-button class="mr-10" type="plainText" text="Cancel" (clickCallback)="openMap=false" ></app-button>
      <app-button type="primaryFilled" text="Add Address" (clickCallback)="addAddress()"  ></app-button>
    </div>
  </app-popover>